<div
  class="flex flex-col items-center justify-center w-full max-w-xl px-10 py-10 overflow-hidden bg-white sm:py-16 sm:px-20 rounded-2xl"
>
  <img class="w-20 mb-2" src="https://kitly.io/storage/images/QDwTAuhD72mkeybRlA6O6twNwuHoPPVseH9lwCgV.png" />
  <div class="text-4xl font-medium text-center sm:text-5xl sm:font-medium sm:text-center">Account Created!</div>
  <div class="text-lg font-medium text-center sm:font-medium">Here’s a billion dollars</div>
  <ui-button (click)="switchAuthMode.emit('login')" classes="mt-6"> Login to your account </ui-button>
</div>
